import Header from "./header";
import { lazy, memo } from "react";

const Footer = lazy(() => import("./footer"));

const UnAuthLayout = ({ children, ...props }) => {
  return (
    <>
      {props.isHeaderFooter && <Header />}
      {children}
      {props.isHeaderFooter && <Footer />}
    </>
  );
};

export default memo(UnAuthLayout);
